export default "__VITE_ASSET__BjJO6Jv9__"